export const TOPBAR_HEIGHT = 46
export const BOTTOMBAR_HEIGHT = 64

export const POPUP_DIMENSIONS = {
  width: 360,
  height: 600,
}

export const SESSION_LENGTH_MS = 30 * 24 * 3600 * 1000
